module.exports = __webpack_public_path__ + "static/media/Ring-Preloader.2407b512.gif";